import { render } from "./PersonalDataConsentField.vue?vue&type=template&id=60e35f33&scoped=true"
import script from "./PersonalDataConsentField.vue?vue&type=script&lang=js"
export * from "./PersonalDataConsentField.vue?vue&type=script&lang=js"

import "./PersonalDataConsentField.vue?vue&type=style&index=0&id=60e35f33&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e35f33"]])

export default __exports__